import React from "react";

import { Link } from "react-router-dom";
import MoldRemediationimg from "../components/MoldRemediationimg";

const MoldRemediationPage = () => {


    const conditionData = {
        image: "./images/image-r.png",
        imagetwo: "./images/image-r-2.png",
        imagethree: "./images/image-r-3.png",
        heading: "We do Mold Remediation",
        intro: "Mold remediation generally requires more than simple clean-up. The goal is also to prevent the mold from recurring. This involves fixing the water problem, drying the excess moisture, cleaning the area, and removing the mold. The true extent of the mold and mold damage is often not determined until the visibly inaccessible areas are opened up.",
        overview: "In many cases, mold intrusion is caused by defective materials, design, or installation. A moldy odor in a building suggests that mold is growing in the building whether or not you see mold.",
        introNote: "Replacing materials or altering a structure to fix a mold problem can be time-consuming and very expensive. There are various ways to remediate mold depending on the circumstance.",
        types: [
            {
                title: "GUIDELINES FOR MOLD REMEDIATION:",
                text: "The guidelines for mold remediation are as follows."
            },
            {
                title: "",
                text: "• CONTAIN the mold from spreading;"
            },
            {
                title: "",
                text: "• KILL the mold;"
            },
            {
                title: "",
                text: "• REMOVE the dead mold;"
            },
            {
                title: "",
                text: "• PROTECT the cleaned-out area against future mold infestations."
            }
        ],
        checklist: [],
        summary: "",
        standards: "",
        contactNote: "",
        bottomTexts: [
            "The way to control mold growth is to control moisture.",
            "Inadequate building ventilation can lead to mold growth."
        ]
    };


    // ✅ ADD KIYA HAI (Dynamic Gallery Data)
    // const galleryData = {
    //     heading: "Mold Remediation",
    //     items: [
    //         {
    //             id: 1,
    //             title: "Before",
    //             img: "/images/After Remediation.jpg",
    //             caption: "Mold Affected Area",
    //         },
    //         {
    //             id: 2,
    //             title: "After",
    //             img: "/images/After Remediation_1.jpg",
    //             caption: "After Mold Remediation",
    //         }
    //     ]
    // };


    return (
        <>
            <div class="common-001">
                <section className="section-banner">
                    <div className="container">
                        <div className="inner-content">
                            <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
                            <h1>
                                Mold<span> Remediation</span>
                            </h1>
                            <p>
                                Discover peace of mind with our expert home inspection services,
                                designed to meet the needs of both real estate agents and
                                property owners. Our team ensures thorough evaluations and
                                prompt reporting, helping you make informed decisions.
                            </p>
                            <div className="dft-btn">
                                <Link to="/industerial-building" className="btn">
                                    For Inspection Services
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="condition-section">
                    <div className="container">
                        <div className="inner-content">
                            <div className="content-wrapper">
                                <div className="top-row row-change">
                                    <div className="left-wrap">
                                        <img src={conditionData.image} alt="Commercial Inspection" />
                                    </div>
                                    <div className="right-wrap">
                                        <h2>{conditionData.heading}</h2>
                                        <p>{conditionData.intro}</p>

                                    </div>
                                </div>
                                <div className="bottom-wrap">
                                    <p>{conditionData.overview}</p>
                                    <p>{conditionData.introNote}</p>
                                    {conditionData.types.map((item, index) => (
                                        <div className="p-data-wrap" key={index}>
                                            <h5>
                                                {item.title}</h5>
                                            <p>{item.text}</p>

                                        </div>
                                    ))}
                                    <ul>
                                        {conditionData.checklist.map((point, index) => (
                                            <li key={index}>{point}</li>
                                        ))}
                                    </ul>
                                    <div className="b-data">
                                        <p>{conditionData.summary}</p>
                                    </div>
                                    <div className="bottom-p think-p">
                                        <p>{conditionData.standards}</p>
                                    </div>
                                    <div className="bottom-p">
                                        <p>{conditionData.contactNote}</p>
                                    </div>
                                </div>
                                <div className="top-row row-change row-top-two">

                                    <div className="right-wrap">
                                        {conditionData.bottomTexts.map((text, index) => (
                                            <p key={index}>{text}</p>
                                        ))}

                                    </div>
                                    <div className="left-wrap">
                                        <div className="img-box-111">
                                            <img src={conditionData.imagetwo} alt="Commercial Inspection" />
                                        </div>
                                        <div className="img-box-111">
                                            <img src={conditionData.imagethree} alt="Commercial Inspection" />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="gallery-section">
                    <div className="container">
                       
                        <div className="section-heading">
                            <h2>{galleryData.heading}</h2>
                        </div>

                        <div className="inner-content">
                            {galleryData.items.map((item) => (
                                <div key={item.id} className="content-box">
                                    <div className="img-box">
                                        <img src={item.img} alt={item.title} />
                                    </div>

                                    <div className="text-box">
                                        <h5>{item.caption}</h5>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}

                <MoldRemediationimg />

            </div>
        </>
    );
};

export default MoldRemediationPage;